export function formatKr(value) {
  const n = Number.isFinite(value) ? value : 0;
  return Math.round(n).toLocaleString('sv-SE');
}
